import { Box, Flex, Heading, Text } from '@agrotoken-tech/ui';
import { ReactNode } from 'react';

interface Props {
  title: string;
  description?: string;
  actions?: ReactNode;
  badge?: ReactNode;
}

export const DigitalDossierHeader = ({
  title,
  description,
  actions,
  badge,
}: Props) => {
  const displayMobile = { base: 'flex', md: 'none' };
  const displayDesktop = { base: 'none', md: 'flex' };

  return (
    <Flex direction={'column'} gap={4}>
      <Flex direction={'column'} gap={1}>
        <Box display={displayMobile}>{badge}</Box>
        <Flex
          justifyContent={'space-between'}
          alignItems={{ base: 'normal', md: 'center' }}
          direction={{ base: 'column', md: 'row' }}
        >
          <Flex alignItems={'center'} gap={4} w={'full'}>
            <Heading
              size={'md'}
              whiteSpace={'nowrap'}
              overflow={'hidden'}
              textOverflow={'ellipsis'}
            >
              {title}
            </Heading>

            <Box display={displayDesktop}>{badge}</Box>
          </Flex>
          {actions && <Box display={displayDesktop}>{actions}</Box>}
        </Flex>
        {description && <Text>{description}</Text>}
      </Flex>
      {actions && <Box display={displayMobile}>{actions}</Box>}
    </Flex>
  );
};
